import {
  legacy_createStore as createStore,
  applyMiddleware,
  // compose
} from 'redux'
import createSagaMiddleware from 'redux-saga'

import {rootReducer,rootSaga} from './rootReducer'

// create the saga middleware
const sagaMiddleware = createSagaMiddleware()
// mount it on the Store
export const store = createStore(
  rootReducer,
  applyMiddleware(sagaMiddleware)
)

//---------this code below is for redux devtool browser extention----------
// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// export const store = createStore(
//   rootReducer,
//   composeEnhancers(
//     applyMiddleware(sagaMiddleware),
//   ));

// then run the saga
sagaMiddleware.run(rootSaga)